export function hitTestRectangle(r1, r2) {
  //Define the variables we'll need to calculate
  //定义我们需要计算的变量
  let hit, combinedHalfWidths, combinedHalfHeights, vx, vy;
  // , direction;

  //hit will determine whether there's a collision
  //hit决定是否有碰撞
  hit = false;

  //Find the center points of each sprite
  //找到每个精灵的中心点
  r1.centerX = r1.x + r1.width / 2;
  r1.centerY = r1.y + r1.height / 2;
  r2.centerX = r2.x + r2.width / 2;
  r2.centerY = r2.y + r2.height / 2;

  //Find the half-widths and half-heights of each sprite
  //找到每个精灵的一半宽度和一半高度
  r1.halfWidth = r1.width / 2;
  r1.halfHeight = r1.height / 2;
  r2.halfWidth = r2.width / 2;
  r2.halfHeight = r2.height / 2;
  //Calculate the distance vector between the sprites
  //计算精灵之间的向量距离
  vx = r1.centerX - r2.centerX;
  vy = r1.centerY - r2.centerY;

  //Figure out the combined half-widths and half-heights
  //计算出两个精灵的的一半宽度和一半高度的和
  combinedHalfWidths = r1.halfWidth + r2.halfWidth;
  combinedHalfHeights = r1.halfHeight + r2.halfHeight;

  //Check for a collision on the x axis
  //检测x轴的碰撞
  if (Math.abs(vx) < combinedHalfWidths) {
    //A collision might be occuring. Check for a collision on the y axis
    //碰撞可能发生，检查y轴碰撞
    if (Math.abs(vy) < combinedHalfHeights) {
      //确实有碰撞发生
      hit = true;
    } else {
      //在y轴没有碰撞
      hit = false;
    }
  } else {
    //在x轴没有碰撞
    hit = false;
  }

  //`hit` 返回 `true` 或者 `false`
  return hit;
}

export function catchDropTest(drop, blanket) {
  //
  
}
